import React, { Component } from "react";
import "./ScanWristband.css";
import scan_qrcode_img from "./images/scan_qrcode_img.png";
import thaiFlag from "./images/thai_flag.png";
import thaiFlagGrey from "./images/thai_flag_grey.png";
import engFlag from "./images/eng_flag.png";
import engFlagGrey from "./images/eng_flag_grey.png";
import cartoon from "./images/cartoon.png";
// Change language
import PropTypes from "prop-types";
import en from "./languages/en.json";
import th from "./languages/th.json";
// Translation Higher Order Component
import {
  setTranslations,
  setDefaultLanguage,
  setLanguageCookie,
  setLanguage,
  translate,
} from "react-switch-lang";

// Do this two lines only when setting up the application
setTranslations({ en, th });
// setDefaultLanguage("en");

// If you want to remember selected language
setLanguageCookie();

const apiUrl =
  "https://centapi.andamandaphuket.com:8443/centaman.api/v3/giftcards?GiftcardNo=";

class ScanWristband extends Component {
  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      current: 0,
      language: "th",
      wristband: "",
      languageStatus: "th",
    };
  }

  handleChange(value) {
    if (value !== this.state.languageStatus) {
      setLanguage(value);
      this.setState({ language: value });
      this.wristbandInput.focus();
    }
  }

  componentDidMount() {
    // Start counting when the page is loaded
    this.timeoutHandle = setTimeout(() => {
      setLanguage("th");
      this.props.history.push("/");
    }, 10000);
    this.wristbandInput.focus();
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutHandle);
  }

  state = {
    result: "No result",
  };

  // getUserDetail = async (wristband) => {
  //   try {
  //     const response = await fetch(apiUrl + wristband, {
  //       method: "GET",
  //       headers: { Authorization: "Basic " + btoa("ANDAMAPI:200acabovul") },
  //     });
  //     const result = await response.json();
  //     const userDetail = result[0];
  //     if (userDetail) {
  //       //3322780051
  //       this.wristbandInput.value = "";
  //       this.setState({ wristband: "" });
  //       this.props.history.push({
  //         pathname: "/page3",
  //         state: {
  //           giftcardNo: userDetail.GiftcardNo,
  //           giftcardExpiryDate: userDetail.GiftcardExpiryDate,
  //           cashOutBalance: userDetail.CashOutBalance,
  //           restrictedBalance: userDetail.RestrictedBalance,
  //           totalBalance: userDetail.TotalBalance,
  //         },
  //       });
  //     } else {
  //       this.wristbandInput.value = "";
  //       this.setState({ wristband: "" });
  //     }
  //   } catch (error) {
  //     this.wristbandInput.value = "";
  //     this.setState({ wristband: "" });
  //     this.props.history.push({
  //       pathname: "/page5",
  //       state: {

  //       },
  //     });
  //   } finally {
  //     // setLoading(false);
  //   }
  // };

  getUserDetail = (wristband) => {
    return new Promise((resolve, reject) => {
      fetch(apiUrl + parseInt(wristband), {
        method: "GET",
        headers: { Authorization: "Basic " + btoa("ANDAMAPI:200acabovul") },
      })
        .then((response) => response.json())
        .then((result) => {
          const userDetail = result[0];

          if (userDetail) {
            this.wristbandInput.value = "";
            this.setState({ wristband: "" });

            const stateData = {
              giftcardNo: userDetail.GiftcardNo,
              giftcardExpiryDate: userDetail.GiftcardExpiryDate,
              cashOutBalance: userDetail.CashOutBalance,
              restrictedBalance: userDetail.RestrictedBalance,
              totalBalance: userDetail.TotalBalance,
            };

            this.props.history.push({
              pathname: "/page3",
              state: stateData,
            });

            resolve(stateData);
          } else {
            this.wristbandInput.value = "";
            this.setState({ wristband: "" });
            resolve(null); // Resolve with null to indicate no user detail
          }
        })
        .catch((error) => {
          this.wristbandInput.value = "";
          this.setState({ wristband: "" });

          this.props.history.push({
            pathname: "/page5",
            state: {
              wristband: wristband,
            },
          });

          reject(error); // Reject with the error
        })
        .finally(() => {
          // setLoading(false);
        });
    });
  };

  // handleWristbandKeyDown = (e) => {
  //   if (e.key === "Enter") {
  //     console.log("Enter press...", e.target.value);
  //     this.setState({ wristband: e.target.value });
  //     this.getUserDetail(e.target.value);
  //   }
  // };

  handleWristbandKeyDown = (e) => {
    if (e.key === "Enter") {
      this.setState({ wristband: e.target.value });
      this.getUserDetail(e.target.value)
        .then((stateData) => {
          if (stateData === null) {
            // Handle case where no user detail was found
            console.log("No user detail found");
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  };

  render() {
    const { t } = this.props;
    return (
      <div className="main">
        <input
          style={{
            opacity: "0",
            width: 0,
            height: 0,
          }}
          autoFocus={true}
          onKeyDown={this.handleWristbandKeyDown}
          ref={(inputEl) => (this.wristbandInput = inputEl)}
        />

        <img
          alt="thai-info"
          className="thaiImg"
          src={this.state.language === "th" ? thaiFlag : thaiFlagGrey}
          value="th"
          onClick={() => {
            this.handleChange("th");
            this.setState({ languageStatus: "th" });
          }}
        />
        <img
          alt="eng-info"
          className="engImg"
          src={this.state.language === "en" ? engFlag : engFlagGrey}
          value="th"
          onClick={() => {
            this.handleChange("en");
            this.setState({ languageStatus: "en" });
          }}
        />
        <p className="thaiTextLang" onClick={() => this.wristbandInput.focus()}>
          ไทย
        </p>
        <p className="engTextLang" onClick={() => this.wristbandInput.focus()}>
          English
        </p>
        <div>
          <p onClick={() => this.wristbandInput.focus()}>{this.state.result}</p>
        </div>
        <div>
          <div
            className="andamandaImg"
            onClick={() => this.wristbandInput.focus()}
          >
            <img
              src={scan_qrcode_img}
              alt="Scan QR code"
              onClick={() => this.wristbandInput.focus()}
            />
          </div>
          <div
            className="infomation"
            onClick={() => this.wristbandInput.focus()}
          >
            {t("touchToscan")}
            <br />
            {t("atReader")}
          </div>
          <div className="cartoonImg">
            <img
              src={cartoon}
              alt="Cartoon"
              onClick={() => this.wristbandInput.focus()}
            />
          </div>
        </div>
      </div>
    );
  }
}

ScanWristband.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate(ScanWristband);
